export default __webpack_public_path__ + "static/media/brain-aura.895dd605.webp";